// src/services/PushNotificationService.js
import api from "../common/apiClient"; // Imported your global api client
import SummaryApi from "../common/SummaryApi";

const PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

// Converts Base64 VAPID key to Uint8Array for browser push manager compatibility
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  return Uint8Array.from(
    [...rawData].map((char) => char.charCodeAt(0))
  );
}

/**
 * Checks browser support, requests notification permissions, 
 * registers service worker, and securely saves push subscriptions to backend [1].
 */
export const subscribeToPush = async () => {
  try {
    // Check browser support
    if (!("serviceWorker" in navigator)) {
      // console.log("❌ Service Worker not supported");
      return;
    }

    if (!("PushManager" in window)) {
      // console.log("❌ Push API not supported");
      return;
    }

    // Verify VAPID Key presence
    if (!PUBLIC_KEY) {
      // console.error("❌ REACT_APP_VAPID_PUBLIC_KEY is missing");
      return;
    }

    // Check notification permission state
    if (Notification.permission === "denied") {
      // console.log("❌ Notifications are blocked by the browser");
      return;
    }

    // Request notification permissions dynamically from the browser
    if (Notification.permission === "default") {
      // console.log("👉 Requesting notification permission...");
      const permission = await Notification.requestPermission();
      // console.log("Permission Result:", permission);

      if (permission !== "granted") {
        // console.log("❌ User denied notification permission");
        return;
      }
    }

    // Register active Service Worker locally
    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      registration = await navigator.serviceWorker.register("/sw.js");
    } else {
      // console.log("✅ Service Worker already registered");
    }

    await navigator.serviceWorker.ready;

    // Create or retrieve active browser push subscription details
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(PUBLIC_KEY),
      });
      // console.log("✅ Push Subscription Created");
    } else {
      // console.log("✅ Existing Push Subscription Found");
    }

    // FIX: Convert the native browser PushSubscription prototype object 
    // to a plain JSON object to prevent Axios from serializing it as an empty {} object [1].
    const subscriptionJson = subscription.toJSON();

    // Securely register the plain JSON payload to the backend [1]
     await api.post(SummaryApi.registerPushNotification.url, {
      subscription: subscriptionJson, // Passed the safe plain JSON object [1]
      browser: navigator.userAgent,
      platform: navigator.platform,
      device: navigator.userAgent,
    });

    // console.log("Register Result:", res.data);
  } catch (error) {
    console.error("❌ Push Registration Error:", error);
  }
};